import IFolderChildren from '../models/folder/IFolderChildren';
import IFolder from '../models/IFolder';
import IErrorResponse from '../models/networking/IErrorResponse';
import networkService from './networkService';

class FolderService {

    async getFolders(parentId?: string): Promise<IFolder[]> {
        let url = '/folders';
        if (parentId) {
            url += `?parentId=${parentId}`;
        }

        const response = await networkService.get<IFolder[]>(url);
        
        if (!response.isSuccessful)  {
            const error = response.data as IErrorResponse;
            throw new Error(error.message);
        }
        
        return response.status === 200 
            ? response.data as IFolder[]
            : [];
    }

    async getFolderById(id: string): Promise<IFolder | undefined> {
        const response = await networkService.get<IFolder>(`/folder/${id}`);
        
        if (!response.isSuccessful)  {
            const error = response.data as IErrorResponse;
            throw new Error(error.message);
        }

        return response.status === 200 
            ? response.data as IFolder
            : null!;
    }

    async countChildren(folderId: string): Promise<IFolderChildren> {
        const response = await networkService.get<IFolderChildren>(`/folder/${folderId}/count-children`);
        
        if (response.isSuccessful)  {
            return response.data as IFolderChildren;
        }
        
        const error = response.data as IErrorResponse;
        throw new Error(error.message);
    }

    async createFolder(folder: IFolder): Promise<boolean> {
        const response = await networkService.put('/folder', folder);
        return response.isSuccessful;
    }

    async updateFolder(folder: IFolder): Promise<boolean> {
        const response = await networkService.patch('/folder', folder);
        return response.isSuccessful;
    }

    async deleteFolder(folderId: string): Promise<void> {
        const result = await networkService.delete(`/folder/${folderId}`);

        if (!result.isSuccessful) {
            const error = result.data as IErrorResponse;
            throw new Error(error.message);
        }
    }
}

const folderService = new FolderService();
export default folderService;